import { render, staticRenderFns } from "./DoctorVisits.vue?vue&type=template&id=5853735d&"
import script from "./DoctorVisits.vue?vue&type=script&lang=js&"
export * from "./DoctorVisits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports